import { render, staticRenderFns } from "./courseClass.vue?vue&type=template&id=0e51876a&scoped=true&"
import script from "./courseClass.vue?vue&type=script&lang=js&"
export * from "./courseClass.vue?vue&type=script&lang=js&"
import style0 from "./courseClass.vue?vue&type=style&index=0&id=0e51876a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e51876a",
  null
  
)

export default component.exports